import type { Component } from 'vue'
import { PhArrowLeft, PhCode } from '@phosphor-icons/vue'
import i18n from '@/i18n'

export interface BlogSettingsNavItemDef {
  id: string
  label: string
  icon: Component
}

export interface BlogSettingsNavGroupDef {
  label: string
  items: BlogSettingsNavItemDef[]
}

export const BLOG_SETTINGS_BACK_ICON = PhArrowLeft

export const BLOG_SETTINGS_NAV_GROUPS: BlogSettingsNavGroupDef[] = [
  {
    get label() { return i18n.global.t('blog.settingsNav.groupLabel') },
    items: [
      { id: 'code', get label() { return i18n.global.t('page.settingsNav.customCode') }, icon: PhCode },
    ],
  },
]

export const BLOG_SETTINGS_SLUGS = BLOG_SETTINGS_NAV_GROUPS.flatMap(group => group.items.map(item => item.id))

export function isBlogSettingsSlug(id: string): boolean {
  return BLOG_SETTINGS_SLUGS.includes(id)
}

export function findBlogSettingsItem(id: string): BlogSettingsNavItemDef | null {
  for (const group of BLOG_SETTINGS_NAV_GROUPS) {
    const item = group.items.find(candidate => candidate.id === id)
    if (item) return item
  }
  return null
}

export function blogSettingsItemRoute(contentId: string, id: string): string {
  return id === 'info'
    ? `/blog/${contentId}/settings/info`
    : `/blog/${contentId}/settings/${id}`
}

export function blogEditorRoute(contentId: string): string {
  return `/blog/${contentId}`
}
